import { LanguageCodeEnum } from '@systemeio/ui'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { russianDeclinationOfNumber } from '../russianDeclinationOfNumber'

type TimeworldsTypes = 'seconds' | 'minutes' | 'hours' | 'days'

const createTimeworldsConfig = (t: TLocoType, languageCode: LanguageCodeEnum) => {
  switch (languageCode) {
    case LanguageCodeEnum.RUSSIAN:
      return (timeValue: number, timeworld: TimeworldsTypes) => {
        switch (timeworld) {
          case 'seconds':
            return russianDeclinationOfNumber(timeValue, [
              t('dashboard.name_of_times.seconds.one'),
              t('dashboard.name_of_times.seconds.several'),
              t('dashboard.name_of_times.seconds.many'),
            ])
          case 'minutes':
            return russianDeclinationOfNumber(timeValue, [
              t('dashboard.name_of_times.minutes.one'),
              t('dashboard.name_of_times.minutes.several'),
              t('dashboard.name_of_times.minutes.many'),
            ])
          case 'hours':
            return russianDeclinationOfNumber(timeValue, [
              t('dashboard.name_of_times.hours.one'),
              t('dashboard.name_of_times.hours.several'),
              t('dashboard.name_of_times.hours.many'),
            ])
          case 'days':
            return russianDeclinationOfNumber(timeValue, [
              t('dashboard.name_of_times.days.one'),
              t('dashboard.name_of_times.days.several'),
              t('dashboard.name_of_times.days.many'),
            ])
        }
      }
    default:
      return (timeValue: number, timeworld: TimeworldsTypes) => {
        if (timeValue <= 1)
          switch (timeworld) {
            case 'seconds':
              return t('dashboard.name_of_times.seconds.one')
            case 'minutes':
              return t('dashboard.name_of_times.minutes.one')
            case 'hours':
              return t('dashboard.name_of_times.hours.one')
            case 'days':
              return t('dashboard.name_of_times.days.one')
          }
        else
          switch (timeworld) {
            case 'seconds':
              return t('dashboard.name_of_times.seconds.plural')
            case 'minutes':
              return t('dashboard.name_of_times.minutes.plural')
            case 'hours':
              return t('dashboard.name_of_times.hours.plural')
            case 'days':
              return t('dashboard.name_of_times.days.plural')
          }
      }
  }
}
const createTimeworldsLowerCase =
  (
    ...argsConfig: Parameters<typeof createTimeworldsConfig>
  ): ReturnType<typeof createTimeworldsConfig> =>
  (...args) =>
    createTimeworldsConfig(...argsConfig)(...args).toLowerCase()

export const formatTimeDuration = (
  durationInSeconds: number,
  t: TLocoType,
  languageCode: LanguageCodeEnum,
): string => {
  const createTimeworlds = createTimeworldsLowerCase(t, languageCode)

  const days = Math.floor(durationInSeconds / (60 * 60 * 24))
  const hours = Math.floor(durationInSeconds / (60 * 60)) % 24
  const minutes = Math.floor(durationInSeconds / 60) % 60
  const seconds = durationInSeconds % 60

  const formattedDays = days ? days + ' ' + createTimeworlds(days, 'days') : ''
  const formattedHours = hours ? hours + ' ' + createTimeworlds(hours, 'hours') : ''
  const formattedMinutes = minutes ? minutes + ' ' + createTimeworlds(minutes, 'minutes') : ''
  const formattedSeconds = seconds ? seconds + ' ' + createTimeworlds(seconds, 'seconds') : ''

  return `${formattedDays} ${formattedHours} ${formattedMinutes} ${formattedSeconds}`
}
